import React from 'react';
import { type IHostProps } from '@wix/yoshi-flow-editor';
import { getTPASettignsLiveSiteEditingDeprecated } from '@wix/communities-blog-client-common';
import { connect } from '../../../common/components/runtime-context';
import { getLayoutPostSize } from '../../../common/selectors/app-settings-selectors';
import { type Actions, type AppState } from '../../../common/types';
import CreatePostButtonDesktop from './create-post-button-desktop';
import PageTabs from './page-tabs';
import PageTitle from './page-title';
import styles from './my-posts-frame-desktop.scss';

type Props = {
  children?: React.ReactNode;
} & ReturnType<typeof mapRuntimeToProps>;

const MyPostsFrameDesktop = ({ children, layoutPostSize, isLiveSiteEditingEnabled }: Props) => (
  <section
    className={styles.root}
    style={{ '--width': layoutPostSize ? `${layoutPostSize}px` : undefined }}
  >
    <div className={styles.contentWrapper}>
      <header className={styles.header}>
        <PageTitle />
        {isLiveSiteEditingEnabled && <CreatePostButtonDesktop />}
      </header>
      <section className={styles.tabs}>
        <PageTabs />
      </section>
      {children}
    </div>
  </section>
);

const mapRuntimeToProps = (
  state: AppState,
  _ownProps: {},
  _actions: Actions,
  host: IHostProps,
) => ({
  layoutPostSize: getLayoutPostSize({
    state,
    hostWidth: host.dimensions.width || undefined,
  }),
  isLiveSiteEditingEnabled: !getTPASettignsLiveSiteEditingDeprecated(state),
});

export default connect(mapRuntimeToProps)(MyPostsFrameDesktop);
